import React, {useCallback} from 'react';
import {useHistory, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import Filter from '@ey/canvascoreservices/Filters';

import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';

import * as ErrorActions from '../../../../../../actions/erroractions';
import {setMessageLogFilter} from '../../../../../../actions/ContactDB';

export const MessageLogFilterButton = ({actions, filterConfiguration, state, dispatch, _syncQueryString}) => {
	const history = useHistory();
	const upToAmount = 25;

	const appliedFiltersAmount = (filters, appliesCurrentFilter = false) => {
		if (filters) {
			const byMessageType = filters.messagelogbymessagetype?.value?.length || 0;
			const bySentBy = filters.messagelogbysentby?.value?.length || 0;
			const byFromEntity = filters.messagelogbyfromentity?.value?.length || 0;
			const byToEntity = filters.messagelogbytoentity?.value?.length || 0;
			const byToCountry = filters.messagelogbytocountry?.value?.length || 0;
			const byToGroupRole = filters.messagelogbytogrouprole?.value?.length || 0;
			const byToEngagement = filters.messagelogbytoengagement?.value?.length || 0;
			const byToServiceLine = filters.messagelogbytoserviceline?.value?.length || 0;
			const byToRole = filters.messagelogbytorole?.value?.length || 0;

			const currentFilter = appliesCurrentFilter ? 1 : 0;

			return (
				byMessageType +
				bySentBy +
				byFromEntity +
				byToEntity +
				byToCountry +
				byToGroupRole +
				byToEngagement +
				byToServiceLine +
				byToRole +
				currentFilter
			);
		}
	};

	const handleSetState = useCallback(
		(filters) => {
			const appliedFilters = appliedFiltersAmount(filters);

			// Avoid adding exceeded filters to filter state.
			if (appliedFilters > upToAmount) {
				return;
			}

			dispatch({
				type: 'state/set',
				value: {
					filters
				}
			});
		},
		[dispatch]
	);

	const handleOnSetFilter = useCallback(
		(filter, value) => {
			const appliedFilters = appliedFiltersAmount(filter.state, true);

			// No more than 25 filters can be applied.
			if (appliedFilters > upToAmount) {
				actions.displayError(labels.filtersWarningMessage);
				return;
			}

			actions.setMessageLogFilter(filter.name, value);
		},
		[actions]
	);

	return (
		<Filter
			syncQueryString
			_syncQueryString={_syncQueryString}
			history={history}
			searchPlaceholder={labels.placeholderForSearch}
			filterKey={filterConfiguration.key}
			filters={filterConfiguration}
			state={state.filters}
			setState={handleSetState}
			onEnableFilter={handleOnSetFilter}
			onDisableFilter={handleOnSetFilter}
			labelYes={labels.filterYes}
			labelNo={labels.filterNo}
			clearHoverText={labels.clearHoverText}
			noFiltersAvailableLabel={labels.noFiltersAvailable}
			noResultsPlaceholder={labels.noResultsAvailable}
			tooltip={labels.filterTooltip}
			theme={Utility.getMotifTheme()}
			searchButtonTitle={labels.search}
		/>
	);
};

const mapStateToProps = (store) => {
	return {
		projectId: store.project.projectId,
		messageLogFilter: store.contactDBFilters
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		setMessageLogFilter: (filterItemName, value) => dispatch(setMessageLogFilter(filterItemName, value)),
		displayError: (message) => dispatch(ErrorActions.raiseJSValidationError(message))
	}
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageLogFilterButton));
